// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2Hq0T","itemTitle":"ClientEmergencyInfo_itemTitle__2TCgA","itemText":"ClientEmergencyInfo_itemText__Adrz_"};